'use client';
import { getBoundingClientRect } from './getBoundingClientRect.js';
import { getDocumentElement, getNodeScroll } from '../../utils/dom.js';

function getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return getBoundingClientRect(getDocumentElement(element)).left + getNodeScroll(element).scrollLeft;
}

export { getWindowScrollBarX };
